import { add } from "date-fns";

export const UI_VERSION_COOKIE = "ui_version";

const cookieDomain = () =>
  typeof location !== "undefined" &&
  location.hostname.endsWith("smartkarma.com")
    ? " domain=.smartkarma.com;"
    : "";

export const setUiVersionCookie = (version: "new" | "legacy") => {
  if (typeof document === "undefined") return;

  const expireTime = add(new Date(), { years: 1 }).toUTCString();

  document.cookie = `${UI_VERSION_COOKIE}=${version};${cookieDomain()} path=/; expires=${expireTime}`;
};
